var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"b-burger-wrapper",class:{ "b-burger-wrapper--active": _vm.isActive },style:(_vm.burgerWrapperStyles),on:{"click":function($event){$event.stopPropagation();return _vm.handleToggleStatus.apply(null, arguments)}}},_vm._l((3),function(i){return _c('div',{key:i,style:(_vm.burgerInnerStyles)})}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }